import { render, staticRenderFns } from "./zhuxue.vue?vue&type=template&id=46b1786a&scoped=true"
import script from "./zhuxue.vue?vue&type=script&lang=js"
export * from "./zhuxue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b1786a",
  null
  
)

export default component.exports